<template>
  <span class="storage-status" v-if="isVisible">
    <span>(</span>
    <span>stored: </span>
    <span class="entities-amount">{{ storedString }}</span>
    <span>; </span>
    <span>limit: </span>
    <span class="entities-amount">{{ limitString }}</span>
    <span>)</span>
  </span>
</template>

<script>
import * as formatUtils from "@/utils/format-utils";

export default {
  name: "StorageStatus",
  props: {
    stored: Number,
    limit: Number,
  },
  data() {
    return {};
  },
  computed: {
    isVisible() {
      return this.stored && this.limit;
    },
    storedString() {
      return this.stored + "";
    },
    limitString() {
      return formatUtils.formatSubscriptionLimit(this.limit);
    },
  },
  methods: {
    formatSubscriptionLimit: formatUtils.formatSubscriptionLimit,
  },
};
</script>
